import { activeOrgSelector } from 'redux/reducer/AuthenticationReducer';
import { axiosInstance } from 'utils/http';
import { liveCleanroom } from 'utils/urlConstants';
import { showAlert } from 'redux/actions/AlertActions';
import { useDispatch, useSelector } from 'react-redux';
import { useMutation } from 'react-query';


export const useSaveWorksheetWarehouse = (crId, lcrId, worksheetId) => {
  const dispatch = useDispatch();
  const { ID: orgId } = useSelector(activeOrgSelector);
  return useMutation(
    (warehouseID) => axiosInstance.put(
      liveCleanroom(orgId).saveWorksheetWarehouse(crId, lcrId, worksheetId),
      { warehouseID },
    ),
    {
      onSuccess: () => {
        dispatch(
          showAlert({
            message: 'Warehouse saved successfully',
            type: 'success',
          }),
        );
      },
      onError: (error) => {
        dispatch(
          showAlert({
            message: error.response?.data?.message || 'Error saving warehouse',
            type: 'error',
          }),
        );
      },
    },
  );
};
